import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { HoverMedia } from '@/components/generals/hover-media'
import { SectionLabel } from '@/components/generals/section-label'
import { JustifiedSplit } from '@/components/studio/justified-split'
import { media } from '@/constants/media'

const STATEMENT = "We care about details most people never notice. We argue about kerning and mean it. Everyone here has taste and gets to use it. Nothing leaves the studio that we wouldn't put our"

const STATEMENT_TAIL = 'own name on.'

export const StudioCulture: FC = (): ReactNode => {
    return (
        <section
            id='studio-culture'
            className='relative z-10 bg-paper text-ink'
        >
            <div className='mx-auto flex max-w-[1920px] flex-col gap-10 px-5 sec lg:gap-16 lg:px-[33px]'>
                <div className='grid grid-cols-1 items-start gap-5 lg:grid-cols-4'>
                    <SectionLabel label='Our culture.' />

                    {/* The two frames drift at different rates, so the pair
                        never reads as one flat plane. */}
                    <Reveal
                        from='up'
                        distance={70}
                        duration={1.3}
                    >
                        <HoverMedia
                            src={media.editorial.deskLight}
                            alt='Late light across the studio desk, proofs and material samples laid out'
                            aspect={0.75}
                            parallax={15}
                        />
                    </Reveal>

                    <Reveal
                        from='up'
                        distance={70}
                        duration={1.3}
                        delay={0.14}
                        className='lg:col-span-2'
                    >
                        <HoverMedia
                            src={media.editorial.floorWide}
                            alt='The studio floor on a working morning'
                            aspect={1.5}
                            parallax={6}
                        />
                    </Reveal>
                </div>

                <JustifiedSplit
                    as='h2'
                    runs={[
                        { text: STATEMENT },
                        { text: STATEMENT_TAIL, className: 'text-brand' }
                    ]}
                    indent={27}
                    stagger={0.006}
                    start='top 88%'
                    className='t-display text-ink'
                    style={{ fontSize: 'clamp(30px, 4.6vw, 60px)' }}
                />
            </div>
        </section>
    )
}
